import React, { useRef } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Download } from 'lucide-react';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const CombinedSCurveChart = ({ data, title }) => {
  const chartRef = useRef(null);

  if (!data) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400">
        <p>No S-Curve data available.</p>
      </div>
    );
  }

  const handleDownloadChart = () => {
    if (chartRef.current) {
      const link = document.createElement('a');
      link.download = `${title.replace(/\s/g, '_')}_S-Curve_Chart.png`;
      link.href = chartRef.current.toBase64Image();
      link.click();
    }
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 12,
            weight: 'bold'
          },
          color: '#333'
        }
      },
      title: {
        display: true,
        text: title,
        font: {
          size: 18,
          weight: 'bold'
        },
        color: '#333'
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.dataset.label}: ${context.parsed.y}%`;
          }
        }
      }
    },
    scales: {
      x: {
        type: 'category',
        title: {
          display: true,
          text: 'Date',
          font: {
            size: 14,
            weight: 'bold'
          },
          color: '#555'
        },
        grid: {
          display: false
        },
        ticks: {
          autoSkip: true,
          maxRotation: 0,
          minRotation: 0
        }
      },
      y: {
        title: {
          display: true,
          text: 'Cumulative Progress (%)',
          font: {
            size: 14,
            weight: 'bold'
          },
          color: '#555'
        },
        min: 0,
        max: 100,
        ticks: {
          stepSize: 10,
          callback: function(value) {
            return value + '%';
          }
        },
        grid: {
          color: 'rgba(200, 200, 200, 0.2)'
        }
      }
    }
  };

  return (
    <div className="relative w-full h-96">
      <Line ref={chartRef} data={data} options={options} />
      <button
        onClick={handleDownloadChart}
        className="absolute top-4 right-4 bg-blue-500 text-white p-2 rounded-full shadow-lg hover:bg-blue-600 transition-colors duration-200 z-10"
        title="Download Chart"
      >
        <Download size={20} />
      </button>
    </div>
  );
};

export default CombinedSCurveChart;